import { onboardingEventKeys } from '@app/features/quick-start/constants';

const isDownloadStep = (path: string, activeStep: string): boolean => {
    switch (path) {
        case 'sample':
        case 'empty':
            return activeStep === '3';
        case 'git':
        case 'upload':
            return activeStep === '4';
        case 'ad_hoc_document_upload':
            return activeStep === 'download_translations';
        default:
            return false;
    }
};

const completeDownloadOnboarding = (hideModal: boolean) => {
    const { finished, path, activeStep } = window.onboardingFlow;

    if (finished || !isDownloadStep(path, activeStep)) return;

    const onboardingEvent = new CustomEvent(onboardingEventKeys.stepCompleted, {
        detail: {
            stepName: activeStep,
            path,
            hideModal,
        },
    });

    document.dispatchEvent(onboardingEvent);
};

export default completeDownloadOnboarding;
